const initialState = {}

export const modalDisplayFlg = (state = initialState, actions) => {
    switch (actions.type) {
        case 'UPDATE_MODAL_DISPLAY_FLG':
            return { ...state, [actions.modalName]: actions.value }
        default:
            return state
    }
}
